import ReachToolTip from '@reach/tooltip'
import '@reach/tooltip/styles.css'
import {ReactNode} from 'react'

export const ToolTip = ({
  label,
  children
}: {
  label: string
  children: ReactNode
}) => {
  return <ReachToolTip label={label}>{children}</ReachToolTip>
}
